export default {
  newDesign: true,
  title: "¡Recibe una clase gratuita y personalizada sobre profesiones creativas digitales sin salir de casa! | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  ageRules: {
    min: 9,
    max: 13,
  },
  parameters: {
    landing_id: "LatQfwdTC",
    segment: 44,
  },
  startPage: {
    footer: true,
    title:
      "Elige el mejor horario para una clase gratuita - ¡solo 5 preguntas!",
    subtitle:
      "💻 Adquirirán experiencia para trabajar creativamente<br>💬 Desarrolla pensamiento creativo y socialización<br>🌐 Solo necesitas PC e internet<br>💙 Más de 100.000 alumnos formados en todo el mundo",
    image: {
      url: "/welcome/fwd_freetc_latam_desktop.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/fwd_freetc_latam_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Reserva tu lugar 🔥 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question: "¿Tu hijo/a pasa más de 10 horas a la semana frente a la computadora o dispositivos?",
      answers: [
        "😦 Más de 10 horas",
        "🤓 Menos de 10 horas"
      ],
    },
    2: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/fwd_freetc_latam_pic1.png",
      subtitle: "Aunque se recomienda que los niños no pasen más de 2 horas diarias en dispositivos, en América Latina a menudo superan las 5 horas. Es aconsejable alternar entretenimiento con actividades productivas, como clases de 1 a 1,5 horas.<br><br>Nuestros programas están diseñados con esto en mente.",
      button: "¡Muy bien!",
    },
    3: {
      question: "¿Qué tan hábil es tu hijo/a con la computadora?",
      answers: [
        "🤔 No tiene conocimientos básicos",
        "🙌 Sabe usar algunas apps (PowerPoint, etc.)",
        "💻 Nivel intermedio, quiere aprender más",
        "🎮 La usa principalmente para juegos",
      ],
    },
    4: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/fwd_freetc_latam_pic2.png",
      subtitle: "Aprovechamos el dominio recreativo de los niños (juegos, YouTube, mensajería) para hacer nuestras clases útiles y entretenidas.<br><br>Los alumnos explorarán la creatividad digital, inspirándose en películas de Disney, y crearán proyectos como gráficos, cómics, animaciones, anuncios y modelos 3D, logrando un impresionante portafolio.",
      button: "¡Vamos!",
    },
    5: {
      question: "¿Tu hijo tiene dificultades para comunicarse con sus compañeros?",
      answers: [
        "😃 No, todo va bien",
        "🙂 Tiene amigos, pero a veces hay problemas",
        "☹️ Le cuesta socializar y hacer amigos",
      ],
    },
    6: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/fwd_freetc_latam_pic3_2.png",
      subtitle: "Es normal que los niños tengan dificultades de comunicación, a menudo debido al entorno social. Pueden sentirse cómodos interactuando con amigos en línea.<br><br>En nuestras clases, les enseñamos conocimientos útiles, trabajo en equipo, oratoria y a hacer nuevos amigos, lo cual se facilita con el trabajo colaborativo.",
      button: "Casi terminamos",
    },
    7: {
      question:
        "¿Tienes una computadora de escritorio o portátil con la que tu hijo puedo estudiar?",
      answers: [
        "💻 Si",
        {
          answer: "☹️ No",
          stopAnswer: true,
        },
      ],
    },
    8: {
      title: "¿Qué edad tiene tu hijo/a?",
      type: "age",
      button: "",
    },
    9: {
      title: "¡Felicitaciones! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Estaremos encantados de recibir a tu hijo/a en nuestra clase gratuita en línea de Creatividad Digital.",
      button: "Finalizar el registro",
    },
    10: {
      title: "Reserva una clase gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Casi terminamos 🔥",
    },
    11: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    12: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    13: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    14: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
